import { HttpClient } from '../http-client';
class PersonalTaskHttpClient extends HttpClient {
    async getPersonalTasks() {
        return this.get('/personal-tasks');
    }
    async updatePersonalTask(personalTaskId, data) {
        return this.put(`/personal-tasks/${personalTaskId}`, data);
    }
    async createPersonalTask(data) {
        return this.post('/personal-tasks', data);
    }
    async deletePersonalTask(personalTaskId) {
        return this.delete(`/personal-tasks/${personalTaskId}`);
    }
}
export const PersonalTaskAPI = new PersonalTaskHttpClient();
